import { action, computed, makeAutoObservable, observable, runInAction } from 'mobx';
import { ENDPOINT, HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { LEGAL_MORTGAGE_KEY_MAP, SolicitorAndLTVType } from 'src/constants/mortgage-payment';

import { ResponseDTO } from 'src/dto/base.dto';
import { GetOfferLetterDTO, InitPaymentDTO, SigningOfferDTO, UpdatePaymentResultDTO } from 'src/dto/mortgage-payment.dto';
import { IMortgageDealOfferLetter, InitializedPaymentResult, InitPayment, ISignOfferLetter, UpdatePaymentResult } from 'src/interfaces/mortgage-deal/mortgage-payment';
import { HttpService } from 'src/services/http.service';
import { IApplicationStore } from '../root/application.store';
export interface IMortgagePaymentStore {
	offerDetail?: IMortgageDealOfferLetter;
	getOfferDetail(mortgageId: string): Promise<boolean>;
	signOfferDetail(request: ISignOfferLetter): Promise<boolean>;
	initPayment(request: InitPayment): Promise<string|undefined>;
	submitBankTransferPayment(form: FormData): Promise<boolean>;
	submitPaymentResult(request: UpdatePaymentResult): Promise<boolean>;
	get mortgageAddress(): string;

}

export class MortgagePaymentStore implements IMortgagePaymentStore {
	offerDetail?: IMortgageDealOfferLetter;

	constructor(private readonly http: HttpService, private readonly appStore: IApplicationStore) {
		makeAutoObservable(this, {
			offerDetail: observable,
			getOfferDetail: action.bound,
			signOfferDetail: action.bound,
			mortgageAddress: computed
		});
	}

	public async initPayment(request: InitPayment): Promise<string|undefined>{
		const dto = new InitPaymentDTO(request);
		const rs: ResponseDTO<InitializedPaymentResult> = await this.http.request(dto);
		if(rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS && rs.data){
			return rs.data.url;
		}
		return undefined;
	}

	public async submitPaymentResult(request: UpdatePaymentResult): Promise<boolean>{
		const dto = new UpdatePaymentResultDTO(request);
		const rs: ResponseDTO<boolean> = await this.http.request(dto);
		if(rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS){
			return true
		}
		return false;
	}
	public async submitBankTransferPayment(form: FormData): Promise<boolean>{
		const rs: ResponseDTO<boolean> = await this.http.uploadFile(ENDPOINT.SUBMIT_BANK_TRANSFER, form);
		if(rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS){
			
			return true;
		}
		return false;
	}

	public get mortgageAddress(): string {
		const countyName = this.appStore.countriesOptions.find((e) => e.value == this.offerDetail?.captionedInvestmentCity);
		const district = this.appStore.provinces.find((e) => e.id == this.offerDetail?.captionedInvestmentDistrict);
		return `${this.offerDetail?.captionedInvestmentAddressLine}, ${this.offerDetail?.captionedInvestmentStreet}, ${district?.name}, ${countyName?.label}`;
	}
	public async getOfferDetail(mortgageId: string): Promise<boolean> {
		const dto = new GetOfferLetterDTO({
			mortgageId
		});
		const res: ResponseDTO<IMortgageDealOfferLetter> = await this.http.request(dto);
		if (res.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				if (res.data) {
					let solicitor = '';

					if (res.data.solicitorsOther) {
						solicitor = res.data.solicitorsOther;
					} else {
						solicitor = LEGAL_MORTGAGE_KEY_MAP[res.data.solicitors as SolicitorAndLTVType];
					}
					this.offerDetail = {
						...res.data,
						solicitors: solicitor,
						legalFeePlusVAT: LEGAL_MORTGAGE_KEY_MAP[res.data.legalFeePlusVAT as SolicitorAndLTVType],
						legalMortgagePlusVAT: LEGAL_MORTGAGE_KEY_MAP[res.data.legalMortgagePlusVAT as SolicitorAndLTVType],
					
					};
				}
			});
			return true;
		}
		return false;
	}
	public async signOfferDetail(request: ISignOfferLetter): Promise<boolean> {
		const dto = new SigningOfferDTO(request);
		const rs: ResponseDTO<boolean> = await this.http.request(dto);
		if (rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			return true;
		}
		return false;
	}
}
